'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerContainer = exports.mapDispatchToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp; // BannerContainer

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';

// api

// components

// action creators


exports.mapStateToProps = mapStateToProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _Banner = require('../components/Banner');

var _Banner2 = _interopRequireDefault(_Banner);

var _banner = require('../modules/banner');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
  // if no hotel campaign, show global campaign
  var banner = state.banner.hotel && (0, _keys2.default)(state.banner.hotel) ? state.banner.hotel : state.banner.global;
  return {
    banner: banner
  };
}

var mapDispatchToProps = exports.mapDispatchToProps = { setBanner: _banner.set };

var BannerContainer = exports.BannerContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BannerContainer, _Component);

  function BannerContainer() {
    (0, _classCallCheck3.default)(this, BannerContainer);
    return (0, _possibleConstructorReturn3.default)(this, (BannerContainer.__proto__ || (0, _getPrototypeOf2.default)(BannerContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(BannerContainer, [{
    key: 'render',


    // XXX: Not needed so far
    // static fetchHotelBanner({ dispatch, state, params }) {
    //   if (!params.hotelID) {
    //     dispatch(clearBanner('hotel'));
    //     return Promise.resolve();
    //   }

    //   const { domains } = state;
    //   return BannerContainer.fetchBanner({
    //     dispatch,
    //     state,
    //     query: {
    //       id: domains.collection[domains.index].id,
    //       hotel: params.hotelID
    //     }
    //   });
    // }

    value: function render() {
      var banner = this.props.banner;


      if ((0, _keys2.default)(banner).length) {
        return _react2.default.createElement(_Banner2.default, { banner: banner });
      }

      return null;
    }
  }], [{
    key: 'fetchBanner',


    // XXX: To workaround https://github.com/makeomatic/redux-connect/issues/45
    //      Create static method for API calls that are needed to be fetched by the parent container
    // TODO: Next step, create a generic way to pass API calls to parent containers
    value: function fetchBanner(_ref) {
      var dispatch = _ref.dispatch,
          state = _ref.state,
          query = _ref.query;
      var urls = state.urls,
          httpRequest = state.httpRequest;

      return (0, _trvFedApiClient2.default)(urls.api.banner, 'GET', query, httpRequest.req, undefined, 2000).then(function (res) {
        var banner = {};
        if (query.hotel) {
          banner.hotel = res;
        } else {
          banner.global = res;
        }
        dispatch((0, _banner.set)(banner));
      }, function (res) {
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
        if (query.hotel) {
          dispatch((0, _banner.clear)('hotel'));
        } else {
          dispatch((0, _banner.clear)('global'));
        }
      });
    }
  }, {
    key: 'fetchGlobalBanner',
    value: function fetchGlobalBanner(_ref2) {
      var dispatch = _ref2.dispatch,
          state = _ref2.state;
      var domains = state.domains;

      return BannerContainer.fetchBanner({ dispatch: dispatch, state: state, query: { id: domains.collection[domains.index].id } });
    }
  }]);
  return BannerContainer;
}(_react.Component), _class.propTypes = {
  banner: _react.PropTypes.object.isRequired
}, _class.defaultProps = {
  banner: {}
}, _temp);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BannerContainer);


//////////////////
// WEBPACK FOOTER
// ./src/containers/BannerContainer.js
// module id = 1233
// module chunks = 0